import React from 'react';
import { Details } from 'nhsuk-react-components';
import { getPickListValues, IterationRuleWithAndClauses } from '../../../utils/ruleUtils.ts';

interface RuleRowPickListValuesProps {
    rule: IterationRuleWithAndClauses;
}

export default function RuleRowPickListValues({
  rule,
}: RuleRowPickListValuesProps) {
  const itemCount = rule.Comparator ? rule.Comparator.split(',').length : 0;

  function renderPickListValues(): React.ReactNode[] {
    const pickListValues = getPickListValues(rule);

    return pickListValues.map((entry, idx) => (
      <span key={entry.Value}>
        {entry.Label}
        {' '}
        (
        {entry.Value}
        )
        {idx < pickListValues.length - 1 ? ', ' : ''}
      </span>
    ));
  }

  return (
    <Details className="nhsuk-u-margin-top-2 nhsuk-u-margin-bottom-2">
      <Details.Summary>
        {itemCount}
        {' '}
        {itemCount === 1 ? 'item' : 'items'}
      </Details.Summary>
      <Details.Text>
        {renderPickListValues()}
      </Details.Text>
    </Details>
  );
}
